import { Box, Grid, styled } from '@mui/material';

export const RequiredDocumentsActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  marginInline: theme.spacing(1)
}));

export const DocumentLoadingContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2)
}));

export const DocumentTransitionsWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));

export const DocumentActionsWrapper = styled(Grid)(() => ({
  display: 'flex'
}));
